import { render, staticRenderFns } from "./CeramicFilterParaEdit.vue?vue&type=template&id=568c8430&"
import script from "./CeramicFilterParaEdit.vue?vue&type=script&lang=js&"
export * from "./CeramicFilterParaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports